import { call, put } from "redux-saga/effects";
import { apiGeneral, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListClientsCnpjActions } from "store/ducks/settings/clients";

import { Client } from "interfaces/client";

export function* listClientsCnpjRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(apiGeneral.get, `/clients?${queryString}`);

    // Sem deduplicar por raiz de CNPJ: o vínculo do Tercerizado é por
    // CNPJ individual (CNPJ completo), então cada cliente vira uma opção.
    const comboOptions = data.map((client: Client) => ({
      value: client.id,
      label: client.cnpj
        ? `${client.company_name} - ${client.cnpj}`
        : client.company_name,
    }));

    yield put(ListClientsCnpjActions.success(comboOptions));
    if (onSuccess) onSuccess(comboOptions);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListClientsCnpjActions.failure(errorMessage));
  }
}
